import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _inheritsLoose from "../../inheritsLoose";
import Intact from 'intact-vue';
import { DropdownItem } from '../dropdown';

var Option =
/*#__PURE__*/
function (_DropdownItem) {
  _inheritsLoose(Option, _DropdownItem);

  function Option() {
    return _DropdownItem.apply(this, arguments) || this;
  }

  var _proto = Option.prototype;

  _proto.defaults = function defaults() {
    return _Object$assign({}, _DropdownItem.prototype.defaults.call(this), {
      value: undefined,
      label: undefined
    });
  };

  return Option;
}(DropdownItem);

export { Option as default };